// extracted by mini-css-extract-plugin
export default {"topic":"ILhB3P","header":"a9Odbn","bg":"RWidxB"};